import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { BaseArticleInsertProcessor } from './base-article-insert.processor';
import { Injectable } from '@angular/core';
import { UserModel } from '@user/model/user.model';
import { GlobalContainer } from '@3d-scene/model3d/global-container';
import { ProjectModel } from '@project/model/project.model';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ProjectHelper } from '@project/helper/project.helper';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { RotateArticlePresenter } from '../../../presenter/rotate-article.presenter';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LineComponentUtils } from '@3d-scene/model3d/util/line-component-utils';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { CompositeArticleCacheManager } from '@article/manager/composite-article-cache.manager';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleManager } from '@article/manager/article.manager';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

@Injectable({ providedIn: 'root' })
export class DefaultArticleInsertProcessor extends BaseArticleInsertProcessor {

  constructor(
      userModel: UserModel,
      globalContainer: GlobalContainer,
      projectModel: ProjectModel,
      projectModelService: ProjectModelService,
      projectArticleService: ProjectArticleService,
      projectMetaElementService: ProjectMetaElementService,
      projectHelper: ProjectHelper,
      localeResourceManager: LocaleResourceManager,
      rotateArticlePresenter: RotateArticlePresenter,
      containerService: ContainerService,
      lineComponentUtils: LineComponentUtils,
      connectionInfoService: ConnectionInfoService,
      articleContainerLoader: ArticleContainerLoader,
      compositeArticleCacheManager: CompositeArticleCacheManager,
      articleContainerFactory: ArticleContainerFactory,
      articleManager: ArticleManager,
      compositeArticleUtils: CompositeArticleUtils,
      articleContainerUtils: ArticleContainerUtils,
      detachArticleUsageService: DetachArticleUsageService,
  ) {
    super(
        userModel,
        globalContainer,
        projectModel,
        projectModelService,
        projectArticleService,
        projectMetaElementService,
        projectHelper,
        localeResourceManager,
        rotateArticlePresenter,
        containerService,
        lineComponentUtils,
        connectionInfoService,
        articleContainerLoader,
        compositeArticleCacheManager,
        articleContainerFactory,
        articleManager,
        compositeArticleUtils,
        articleContainerUtils,
      detachArticleUsageService,
    );
  }
  public findGivingCubeByConnectionArea(containers: ArticleContainer[], baseContainer: ArticleContainer,
    connectionArea: ConnectionAreaVO): Connection {
    return baseContainer.findFirstConnectionByName(connectionArea.name);
  }
}
